import { toast } from "sonner";
import { Linkedin, Mail, Copy, BookOpen } from "lucide-react";

const btn = "inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100 transition-colors";

// Guide links carry the partner's ref code, so requests from them are credited to the partner for 90 days.
export const PartnerGuides = ({ guides, code, partnerName }) => {
  if (!guides?.length) return null;
  const link = (slug) => `${window.location.origin}/resources/${slug}?ref=${code}&utm_source=partner&utm_medium=referral&utm_campaign=guide`;
  const copy = (url) => navigator.clipboard.writeText(url).then(() => toast.success("Link copied")).catch(() => toast.error(url));
  return (
    <section data-testid="partner-guides">
      <h2 className="font-display text-lg font-bold flex items-center gap-2 mb-1"><BookOpen className="h-5 w-5 text-emerald-600" />Share our guides</h2>
      <p className="text-sm text-slate-500 mb-4">Send these to borrowers. Anyone who requests a study within 90 days of opening your link is credited to you.</p>
      <div className="divide-y divide-slate-200 rounded-xl border border-slate-200">
        {guides.map((g) => {
          const url = link(g.slug);
          return (
            <div key={g.slug} className="p-4 flex flex-wrap items-center gap-3" data-testid={`partner-guide-${g.slug}`}>
              <div className="flex-1 min-w-0 sm:min-w-[260px]">
                <a href={url} target="_blank" rel="noreferrer" className="font-semibold hover:text-emerald-700">{g.title}</a>
                {g.meta_description && <p className="text-xs text-slate-500 line-clamp-2 mt-0.5">{g.meta_description}</p>}
              </div>
              <div className="flex flex-wrap gap-2">
                <button type="button" className={btn} data-testid={`partner-guide-linkedin-${g.slug}`} onClick={() => window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, "_blank", "noopener,noreferrer,width=640,height=600")}><Linkedin className="h-3.5 w-3.5" />LinkedIn</button>
                <a className={btn} data-testid={`partner-guide-email-${g.slug}`} href={`mailto:?subject=${encodeURIComponent(g.title)}&body=${encodeURIComponent(`Hi,\n\nThis guide may help with your loan application:\n\n${g.title}\n${url}\n\n${partnerName}`)}`}><Mail className="h-3.5 w-3.5" />Email</a>
                <button type="button" className={btn} data-testid={`partner-guide-copy-${g.slug}`} onClick={() => copy(url)}><Copy className="h-3.5 w-3.5" />Copy link</button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
